import http from '@/utils/http';
const baseUrl = '/contrato-originacao/subempresa';

export default {
    totalizadores() {
        return http.get({
            url: baseUrl + '/totalizadores',
            lockScreen: false
        });
    },
    statusSubEmpresa() {
        return http.get({
            url: baseUrl + '/status',
            lockScreen: false
        });
    },
    contratos(dados, params) {
        return http.post({
            url: baseUrl + `?page=${params.page}&size=${params.size}&sort=${params.sort},${params.por}`,
            data: dados,
            lockScreen: false
        });
    }
};
